export default __webpack_public_path__ + "web/react/components/cookie-consent-modal/images/cookie-icon.9960b8e622920c46fe79cc69048880a8.png";